import { makeStyles } from '~styles';
import { ifFeature } from '@bamboohr/utils/lib/feature';
import { mediumScreenWidth } from '~definitions/json/mobile.json';

export const useHeaderStyles = makeStyles()(theme => {
	const { breakpoints, constructs, palette, spacing } = theme;

	return {
		header: {
			alignItems: 'center',
			backgroundColor: ifFeature('encore', palette.common.white, palette.gray[100]),
			borderBottom: ifFeature('encore', `1px solid ${palette.gray[200]}`, `1px solid ${palette.gray[300]}`),
			borderTopLeftRadius: ifFeature('encore', '16px'),
			borderTopRightRadius: ifFeature('encore', '16px'),
			display: 'flex',
			flexShrink: '0',
			padding: ifFeature('encore', spacing(0.5, 2.5), '0 32px'),

			[breakpoints.down(mediumScreenWidth)]: ifFeature('encore', {
				backgroundColor: constructs.surface.neutral.xxWeak,
				padding: 0,
			}),

			// startCleanup encore
			minHeight: ifFeature('encore', undefined, '80px'),
			[breakpoints.down('md')]: {
				padding: ifFeature('encore', undefined, spacing(0, 3)),
			},
			// endCleanup encore
		},
	};
});
